
















import Vue, { PropType } from 'vue'
import { CardOptionType } from '@/constants/scripts'
import { Point, AppColor } from '../../@types'

export interface LinkCoords {
  from: Point
  to: Point
  zoom: number
}

const L_RIGHT = 112
const PAD = 2
const OPTION_HEIGHT_2 = 24

export default Vue.extend({
  props: {
    coords: {
      type: Object as PropType<LinkCoords>,
      required: true,
    },

    color: {
      type: String,
      required: false,
      default: '5E45B5',
    },

    num: {
      type: Number,
      required: true,
    },

    isLink: {
      type: Boolean,
      required: false,
      default: false,
    },

    link: {
      type: Number,
      required: false,
      default: 0,
    },

    type: {
      type: Number as PropType<CardOptionType>,
      required: true,
    },

    isTarget: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  computed: {
    linkColor(): string {
      return this.type === CardOptionType.Final && this.isTarget === true
        ? AppColor.Green
        : this.color
    },

    bgColor(): Record<string, string> {
      let backgroundColor = `#${this.color}`
      if (this.type === CardOptionType.Final && this.isTarget) {
        backgroundColor = `#${AppColor.Green}`
      }
      return {
        backgroundColor,
      }
    },

    isToCard(): boolean {
      return this.type === CardOptionType.Card
    },

    isToScript(): boolean {
      return this.type === CardOptionType.Script
    },

    isToFinal(): boolean {
      return this.type === CardOptionType.Final
    },

    finalIconClasses(): string {
      return this.isTarget ? 'zmdi-gps-dot' : 'zmdi-stop'
    },

    isGoTop(): boolean {
      return this.coords.from.y > this.coords.to.y
    },

    top(): number {
      return this.coords.from.y > this.coords.to.y
        ? this.coords.from.y
        : this.coords.to.y
    },

    topDy(): number {
      if (this.isGoTop) {
        return -this.height + OPTION_HEIGHT_2 - PAD
      }
      return OPTION_HEIGHT_2 - PAD
    },

    height(): number {
      const height = Math.abs(
        (this.coords.from.y - this.coords.to.y) / this.coords.zoom,
      )
      return height > 2 ? height : 2
    },

    width(): number {
      return (this.coords.to.x - this.coords.from.x) / this.coords.zoom
    },

    svgHeight(): number {
      return this.height + PAD * 2
    },

    optionStyles(): Record<string, string> {
      const top = this.isToCard
        ? `${this.topDy}px`
        : `${OPTION_HEIGHT_2 - PAD}px`
      return {
        top,
      }
    },

    dxLeft(): number {
      const dx = (this.width * 0.6) / 9
      if (this.isGoTop) {
        return this.width * 0.4 + this.num * dx
      }
      if (this.num > 2) {
        return this.width * 0.8 - (this.num - 2) * dx
      }
      return this.width * 0.8
    },

    trajectory(): string {
      if (!this.isToCard || this.isLink) {
        return `M0 ${PAD} H 24`
      }
      if (this.isGoTop) {
        return `M0 ${this.height} H ${this.dxLeft} V ${PAD} H ${L_RIGHT}`
      }
      return `M0 ${PAD} H ${this.dxLeft} V ${this.height} H ${L_RIGHT}`
    },

    isShowingTarget(): boolean {
      return this.type !== CardOptionType.Card || this.isLink
    },

    // TODO: Show Card Name
    // targetTooltipContent(): string {
    //   if (this.type === CardOptionType.Card) {
    //     return 'Шаг '
    //   } else if (this.type === CardOptionType.Script) {
    //     return 'Скрипт '
    //   }

    //   return 'Завершение'
    // },

    // targetTooltipClasses(): string {
    //   return ''
    // },
  },
})
